import Vue from 'vue'
import Vuex from 'vuex'
import Utils from '../script/utils.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userModel: {},
    // 用户权限菜单
    roleMenuList:[],
    patientModel:{},
    // 设计页面Loading数量，为0时Loading结束
    designLoadCount: 0
  },
  //全局同步步方法
  mutations: {
    setUserModel: function(state, model) {
      //存入本地sessionStorage
      sessionStorage.setItem("userInfo", JSON.stringify(model));
      state.userModel = Utils.clone(model)
    },
    setPatientModel: function(state, model) {
      //存入本地sessionStorage
      sessionStorage.setItem("patientModel", JSON.stringify(model));
      state.patientModel = Utils.clone(model)
    },
    // 设置动态表单实现页面需要加载的Loading数量
    setDesignLoadCount(state, count) {
      state.designLoadCount = count
    },
    // 调用方法 designLoadCount-1
    reduceSesignLoadCount(state) {
      state.designLoadCount--
    },
    // 设置用户菜单权限
    setRoleMenuList: function(state, model) {
      state.roleMenuList = Utils.clone(model)
    },
  },
  //全局异步方法
  actions: {},
  modules: {}
})
